import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { apiRequest } from "src/async/apiUtils";
import AppRoutes from "src/routes/AppRoutes";
import Preloader from "./LoadingAnimations/Preloader";

const CustomDomainRedirector = () => {
  const { pathname } = useLocation();

  const getCustomDomainStatus = async () => {
    try {
      const { data } = await apiRequest("GET", `settings/custom-domain/status`);
      const redirectUrl = window.location.href.replace(window.location.origin, `https://${data?.data?.custom_domain}`);
      window.location.replace(redirectUrl);
    } catch (err) {}
  };

  useEffect(() => {
    getCustomDomainStatus();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  <Preloader />;

  return <AppRoutes />;
};

export default CustomDomainRedirector;
